import { render } from "./PhdFilterContainer.vue?vue&type=template&id=14fc98ba&ts=true"
import script from "./PhdFilterContainer.ts?vue&type=script&lang=ts&external"
export * from "./PhdFilterContainer.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__